import Lenis from '@studio-freight/lenis';

let instance;

/**
 * Lenis Declaration
 * @returns {Core}
 */
export default function useLenis() {
  if (instance) {
    return instance;
  }

  /**
   * Taxi Core
   */
  instance = new Lenis();

  return instance;
}
